<template>
  <div class="container card text-start">
    <div class="title-font fs-1 m-3">Resources</div>
    <div>
      <div class="alert alert-primary">
        Below is an extensive list of further resources for each competency
        area.
      </div>
    </div>
    <div
      v-for="(recs, topic) in groupedRecommendations"
      :key="topic"
      class="m-4"
    >
      <div class="fw-bold fs-4 title-font">
        {{ topic }}
      </div>
      <div
        v-for="rec in recs"
        :key="rec.opportunityForImprovementId"
        class="text-start m-1"
      >
        <a
          class="icon-link text-decoration-none text-dark"
          :href="rec.opportunityForImprovementUrl"
          :title="rec.opportunityForImprovementText"
          target="_blank"
        >
          <i class="bi bi-link"></i>
          {{ rec.opportunityForImprovementText }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ResourcesView",
  components: {},
  computed: {
    ...mapGetters(["getQuestionData", "getRecommendationData"]),
    groupedRecommendations() {
      // This method takes all the recommendations and all the questions with topics and returns the corresponding unique resources per each topic

      // Use reduce to iterate over getQuestionData and group recommendations by topic
      const grouped = this.getQuestionData.reduce((acc, question) => {
        // Filter recommendations to find those that match the current question's UUID
        const matchingRecs = this.getRecommendationData.filter(
          (rec) => rec.questionUUID === question.uuid
        );

        if (matchingRecs.length > 0) {
          // Initialize the topic in the accumulator if it doesn't exist
          if (!acc[question.topic]) {
            acc[question.topic] = new Map(); // Use Map so that there are only unique resources
          }

          // Iterate over the matching recommendations
          matchingRecs.forEach((rec) => {
            // Add the recommendation to the Map, using the URL as the key
            acc[question.topic].set(rec.opportunityForImprovementUrl, rec);
          });
        }
        return acc;
      }, {});

      // Convert Maps to arrays for the v-for in the template
      const groupedAsArrays = Object.keys(grouped).reduce((acc, topic) => {
        // Convert each Map to an array of its values
        acc[topic] = Array.from(grouped[topic].values());
        return acc;
      }, {});

      return groupedAsArrays;
    }
  },
  created() {
    this.fetchQuestionData();
    this.fetchRecommendationData();
  },
  methods: {
    ...mapActions(["fetchQuestionData", "fetchRecommendationData"])
  }
};
</script>

<style scoped>
.icon-link:hover {
  text-decoration: underline !important;
}
</style>
